import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { RewardCard } from '../components/RewardCard';
import axios from 'axios';
import { API } from '../utils/api';
import { toast } from 'sonner';

export const ShopPage = ({ user, onUserUpdate }) => {
  const [rewards, setRewards] = useState(() => {
    try { const c = JSON.parse(localStorage.getItem('ferraz_shop_cache')); return c?.data || []; } catch { return []; }
  });

  useEffect(() => {
    fetchRewards();
  }, []);

  const fetchRewards = async () => {
    try {
      const response = await axios.get(`${API}/rewards`);
      setRewards(response.data);
      try { localStorage.setItem('ferraz_shop_cache', JSON.stringify({ data: response.data })); } catch (e) { console.warn('[ShopPage] non-critical failure', e); }
    } catch (error) {
      console.error('Error fetching rewards:', error);
    }
  };

  const handlePurchase = async (rewardId) => {
    try {
      const response = await axios.post(`${API}/rewards/${rewardId}/purchase`);
      toast.success('Recompensa resgatada com sucesso!');
      
      const userRes = await axios.get(`${API}/users/me`);
      onUserUpdate(userRes.data);
    } catch (error) {
      toast.error(
        error.response?.data?.detail || 'Erro ao resgatar recompensa'
      );
    }
  };

  return (
    <div className="p-6 md:p-8 lg:p-12 space-y-8" data-testid="shop-page">
      <motion.div initial={{ opacity: 0, y: -20 }} animate={{ opacity: 1, y: 0 }}>
        <h1 className="font-primary font-black text-5xl text-white uppercase tracking-tighter">
          Loja
        </h1>
        <p className="text-zinc-400 font-secondary text-lg mt-2">
          Troque suas FerCoins por recompensas incríveis
        </p>
        <div className="mt-4 inline-flex items-center gap-3 bg-zinc-900/50 border border-yellow-500/30 rounded-full px-6 py-3">
          <img src="/fercoin.png" alt="FerCoin" className="w-8 h-8" />
          <span className="text-zinc-400">Suas FerCoins:</span>
          <span className="font-primary font-black text-2xl text-yellow-400">
            {user?.coins || 0}
          </span>
        </div>
      </motion.div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {rewards.map((reward, index) => (
          <motion.div
            key={reward.id}
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: index * 0.05 }}
          >
            <RewardCard
              reward={reward}
              userCoins={user?.coins || 0}
              onPurchase={handlePurchase}
            />
          </motion.div>
        ))}
      </div>

      {rewards.length === 0 && (
        <motion.div
          className="text-center py-16"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
        >
          <p className="text-zinc-500 text-lg mb-4">
            Nenhuma recompensa disponível no momento.
          </p>
          <p className="text-zinc-600">
            Seu trainer adicionará recompensas em breve!
          </p>
        </motion.div>
      )}
    </div>
  );
};
